<!-- Create Dynamic Client -->
<span id="openTemplateModal" data-bs-target="#Generatemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="Generatemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static" >
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span
                        *ngIf="EditCEInputProperty.details.Dynamictype == 'Client'"> Generate Client Form
                    </span>
                    <span *ngIf="EditCEInputProperty.details.Dynamictype == 'Employee'"> Generate Employee Form
                    </span>
                </h5>
                <button type="button" data-bs-dismiss="modal" class="btn-close" aria-label="Close" (click)="closeEdit()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row mb-2">
                    <div class="col-lg-4">
                    </div>
                    <div class="col-lg-8">
                        <input type="radio"  name="choose" value="global" id="22"
                        [(ngModel)]="selectrole"  (change)="onRoleChange()">
                        <label class="mt-2 mr-3 ml-1">Global</label>

                        <input type="radio" class="ml-3" name="choose" value="agency" id="23"
                       [(ngModel)]="selectrole"   (change)="onRoleChange()" >
                        <label class="mt-2 ml-1">Agency</label>
                    </div>
                </div>
                 <!-- Select Group -->
                 <!-- <div class="row">
                    <div class="col-lg-4">
                        <label style="font-weight: 600;margin-top:6px;">Select Group<span
                                class="super-script">*</span>
                        </label>
                    </div>
                    <div class="col-lg-8">
                        <div class="">
                            <ng-select [searchable]="true" [clearable]="true" [items]="GroupNameList"
                                [(ngModel)]="GroupFilter" bindLabel="label" bindValue="value"  (ngModelChange)="selectTemplate(GroupFilter)">
                            </ng-select>
                        </div>
                    </div>
                </div> -->

                <!-- Select Template Nam -->
                <div class="row">
                    <div class="col-lg-4">
                        <label style="font-weight: 600;margin-top:6px;">Select Template Name<span
                                class="super-script">*</span>
                        </label>
                    </div>
                    <div class="col-lg-8">
                        <div class="">
                            <!-- [disabled]="GroupFilter==undefined||GroupFilter==''||GroupFilter==null" -->
                            <ng-select [searchable]="true" [clearable]="true" [items]="dynamicFormTemplateType" 
                                [(ngModel)]="generateDynamicFormBO.templateId" bindLabel="Value" bindValue="Key">
                            </ng-select>
                        </div>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="isSaveorUpdateBoolean || generateDynamicFormBO.templateId==null ||
                generateDynamicFormBO.templateId==undefined || generateDynamicFormBO.templateId==''"
                    (click)="generateDynamicForms();FileURl=null"><span> Generate</span>
                </button>
                <!-- ||GroupFilter==null ||
                GroupFilter==undefined || GroupFilter=='' " -->
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="closeEdit()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Genereate Pdf-->
<span id="openPdfModal" data-bs-target="#PDFModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="PDFModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog" style="max-width: 100%; margin: 0; top: 0; bottom: 0; left: 0; right: 0; height: 100vh; display: flex; position: fixed; z-index: 100000;" >
        <div class="modal-content">
            <div class="modal-header card-show">
               
            
                
                    <div class="col-lg-3">
                        <h5 class="modal-title font-header" id="exampleModalLabel"><span
                            *ngIf="EditCEInputProperty.details.Dynamictype == 'Client'"> View
                            Client Form </span>
                        <span *ngIf="EditCEInputProperty.details.Dynamictype == 'Employee'"> View
                            Employee Form </span>
                    </h5>
                    </div>
                         <div class="col-lg-8">
         
                            <button type="button" class="btn blue-btn btn-sm text_right ml-1 mb-1 " data-bs-dismiss="modal">Close</button>
                             
                            <button type="button"class="btn blue-btn btn-sm text_right ml-1 mb-1 "(click)="saveEditedPdf()" [disabled]="isSaveorUpdateBoolean">Save</button>
     
                         </div>
                   
            </div>
            <div class="modal-body" *ngIf="FileURl!=null &&  FileURl!=undefined && FileURl!=''">
                <!-- <ngx-extended-pdf-viewer [src]="this.FileURl" [textLayer]="true" [showHandToolButton]="true"
                    [showToolbar]="false" #pdfViewer>
                </ngx-extended-pdf-viewer> -->

                <ngx-extended-pdf-viewer [src]="this.FileURl" useBrowserLocale="true"></ngx-extended-pdf-viewer>
            </div>
            <div class="modal-footer">
               
            </div>
        </div>
    </div>
</div>